<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm" (click)="onClose()">
  <div class="relative w-full max-w-2xl bg-white/95 dark:bg-slate-900/95 rounded-[2rem] shadow-2xl border p-6 md:p-8 max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <div *ngIf="isLoading()" class="py-16 text-center text-slate-400">กำลังโหลด...</div>

    <ng-container *ngIf="detail as d">
      <div class="flex items-center justify-between mb-6">
        <h3 class="text-xl font-bold">{{ d.name }}</h3>
        <button (click)="onClose()"><span class="material-icons text-slate-400">close</span></button>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div class="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 text-center">
          <div class="text-xs text-slate-400">Approved</div>
          <div class="text-2xl font-bold">{{ d.quotaApproved }}</div>
        </div>
        <div class="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 text-center">
          <div class="text-xs text-slate-400">Used</div>
          <div class="text-2xl font-bold">{{ d.quotaUsed }}</div>
        </div>
        <div class="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 text-center">
          <div class="text-xs text-slate-400">Allocated</div>
          <div class="text-2xl font-bold">{{ d.quotaAllocated }}</div>
        </div>
        <div class="p-4 rounded-xl bg-emerald-50 dark:bg-emerald-900/20 text-center">
          <div class="text-xs text-emerald-600">คงเหลือ</div>
          <div class="text-2xl font-bold text-emerald-600">{{ d.quotaRemaining }}</div>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-3 text-sm mb-6">
        <div><span class="text-slate-400">Level:</span> {{ levelLabel(d.quotaLevel) }}</div>
        <div><span class="text-slate-400">สถานะ:</span> {{ statusLabel(d.quotaStatus) }}</div>
        <div><span class="text-slate-400">Scope:</span> {{ d.cardScope }}</div>
        <div><span class="text-slate-400">Site:</span> {{ d.siteName || '-' }}</div>
      </div>

      <div *ngIf="d.recentAllocations?.length">
        <h4 class="font-bold mb-3">การจัดสรรล่าสุด</h4>
        <table class="w-full text-sm">
          <thead class="text-xs text-slate-400 uppercase">
            <tr>
              <th class="py-2 text-left">ร้าน</th>
              <th class="py-2 text-center">จำนวน</th>
              <th class="py-2 text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let a of d.recentAllocations" class="border-t">
              <td class="py-2">{{ a.tenantClientName }}</td>
              <td class="py-2 text-center">{{ a.allocatedQty }}</td>
              <td class="py-2 text-center">{{ a.action }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</div>
